module.exports = __webpack_public_path__ + "static/button1-48f2fb35bde6436a9add2cac065ad622.png";